const createKeywordRegex = (keywords: string[]) => {
  return new RegExp(`(${keywords.join('|')})`, 'i');
};

export const hasKeywords = (text: string, keywords: string): boolean => {
  if (!text || typeof text !== 'string') {
    return false;
  }
  const KEYWORD_REGEX = createKeywordRegex(keywords.split(', '));

  return KEYWORD_REGEX.test(text);
};
